export default "__VITE_ASSET__DtV3b43b__"